import type React from 'react';
import { lazy, Suspense } from 'react';
import { PageLoading } from '@/app/components/page-loading.tsx';

const LazyChatHome = lazy(() => import('./ChatHome'));

const ChatHome = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={<PageLoading />}>
    <LazyChatHome {...props} />
  </Suspense>
);

export const chatHomeRoute = {
  path: '/chat-home',
  element: <ChatHome />,
};

export default ChatHome;
